import { SSRBannerManager } from '../src/SSRBannerManager.ts';

export const ssrBannerManager = new SSRBannerManager();
